import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import FileDownload from "components/Varios/FileDownload.js";

export default class CardDireccionTesis extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    render() {

        return (
            <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardBody>
                        <CardText>
                            <b>{this.props.objeto.titulotesis}</b>
                            <br />
                            <br />
                            <span className="spanCard">TIPO DE PROYECTO: </span>{this.props.objeto.strTipo}
                            <br />
                            <span className="spanCard">NIVEL: </span>{this.props.objeto.strSubtipo}
                            <br />
                            <span className="spanCard">AÑO: </span>{this.props.objeto.anio}
                            <br />
                            <span className="spanCard">PAÍS: </span>{this.props.objeto.strPais}
                            <br />
                            <span className="spanCard">INSTITUCIÓN: </span>{this.props.objeto.institucion}
                            <br />
                            <br />
                            <span className="spanCard">CINE </span>
                            {this.props.objeto.strAreacampoamplio}
                            <br />
                            <span className="spanCard">FRASCATI </span>
                            {this.props.objeto.strAreafrascati}
                            <br />
                            {
                                this.props.objeto.strAreacampoamplio2 ?
                                    <>
                                        <br />
                                        <span className="spanCard">CINE 2: </span>
                                        {this.props.objeto.strAreacampoamplio2}
                                    </>
                                    :
                                    null
                            }
                            {
                                this.props.objeto.strAreafrascati2 ?
                                    <>
                                        <br />
                                        <span className="spanCard">FRASCATI 2: </span>
                                        {this.props.objeto.strAreafrascati2}
                                    </>
                                    :
                                    null
                            }
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            <FileDownload files={this.props.evidencias} card={true} icon="download" />
                            <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                        </div>
                    </CardFooter>
                </Card>
            </div>
        )

    }
}